import { Link } from '@mui/material'
import { useFlags } from 'launchdarkly-react-client-sdk'
import { UIMatch, generatePath } from 'react-router-dom'
import { DynamicBreadcrumb } from 'routes/breadcrumbs'
import { routePaths } from 'routes/route-paths'
import { prepareRoutes } from 'routes/utils/prepareRoutes'

export const useOrgOpenEnrollmentRoutes = () => {
	const { b4b_32681_oewindowupdates: isOeWindowUpdatesEnabled } = useFlags()

	return {
		path: routePaths.organizations.edit.openEnrollment.path,

		name: 'Open Enrollments',
		handle: {
			crumb: (data: UIMatch<any, any>) => (
				<Link
					href={generatePath(routePaths.organizations.edit.openEnrollment.path, {
						id: data.params.id ?? '',
					})}
				>
					Open Enrollments
				</Link>
			),
		},
		children: prepareRoutes(
			[
				{
					index: true,
					lazy: () =>
						isOeWindowUpdatesEnabled
							? import('pages/open-enrollment-windows').then((module) => ({
									Component: module.default,
								}))
							: import('pages/open-enrollment-windows/open-enrollment-windows-legacy').then((module) => ({
									Component: module.default,
								})),
				},
				{
					lazy: () =>
						import('pages/edit-open-enrollment').then((module) => ({
							Component: module.EditOpenEnrollmentLayout,
						})),
					path: routePaths.organizations.edit.openEnrollment.edit.path,
					children: prepareRoutes(
						[
							{
								path: `*`,
								lazy: () =>
									import('pages/edit-open-enrollment').then((module) => ({
										Component: module.default,
									})),
							},
							{
								path: routePaths.organizations.edit.openEnrollment.eligibilityRules.path,
								lazy: () =>
									import('pages/eligibility-rules').then((module) => ({
										Component: module.default,
									})),
							},
						],
						{ stripLeading: `${routePaths.organizations.edit.openEnrollment.edit.path}/` },
					),
					handle: {
						crumb: (data) => <DynamicBreadcrumb portalId={data.params.oeWindowId ?? ''} />,
					},
				},
				{
					lazy: () => import('pages/create-open-enrollment').then((module) => ({ Component: module.default })),
					path: routePaths.organizations.edit.openEnrollment.create.path,
				},
			],
			{ stripLeading: `${routePaths.organizations.edit.openEnrollment.path}/` },
		),
	}
}
